/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partnerssaved1Inputs */

const en_partnerssaved1 = /** @type {(inputs: Partnerssaved1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Partner saved`)
};

const de_partnerssaved1 = /** @type {(inputs: Partnerssaved1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Partner gespeichert`)
};

/**
* | output |
* | --- |
* | "Partner saved" |
*
* @param {Partnerssaved1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const partnerssaved1 = /** @type {((inputs?: Partnerssaved1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partnerssaved1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_partnerssaved1(inputs)
	return de_partnerssaved1(inputs)
});
export { partnerssaved1 as "partnersSaved" }